import React, { useEffect, useState } from 'react';
import { CdsContentPanel } from 'clayco-component-library/lib';
import { useParams } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import ApiProvider from '../../../apiProvider';
import Spinner from '../../skills-experience/shared/spinner';

const ContactVerification = () => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const { type, guid } = useParams();

    const [verificationError, setVerificationError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("no error message found, please contact IT.");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        verifyContactInfo();
    }, []);

    async function verifyContactInfo() {
        try {
            const result = await apiProvider.Patch("Profile/VerifyContactInfo", { id: guid });

            console.log("result: ", result);

            if (result?.error?.type == "Error") {
                setVerificationError(true);
                setErrorMessage(result?.error?.message || "no error message found, please contact IT.");
            }
        } catch (error) {
            console.error("Verification failed: ", error);
            setVerificationError(true);
        } finally {
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return <Spinner show={true} text={"Verifying your contact info..."}/>; // ✅ Use Spinner during async verification
    }

    if (verificationError) {
        return (
            <CdsContentPanel title="Something Went Wrong">
                Something went wrong while verifying your contact information. Please Contact IT for assistance.
                <br />
                <br />
                Error Message:
                <br />
                {errorMessage.length > 250
                    ? `${errorMessage.slice(0, 250)}...`
                    : errorMessage}
            </CdsContentPanel>
        );
    }

    if (type === "Email") {
        return (
            <CdsContentPanel title="Personal Email Verification">
                You have successfully verified your personal email address and can close this page.
            </CdsContentPanel>
        );
    }

    if (type === "Phone") {
        return (
            <CdsContentPanel title="Personal Phone Verification">
                You have successfully verified your personal phone number and can close this page.
            </CdsContentPanel>
        );
    }

    return (
        <CdsContentPanel title="Something Went Wrong">
            Something went wrong while verifying your contact information.
            <br />
            <br />
            Error Message:
            <br />
            {errorMessage.length > 250
                ? `${errorMessage.slice(0, 250)}...`
                : errorMessage}
        </CdsContentPanel>
    );
};

export default ContactVerification;